/* Hide the video loader once the player is actually up.
   An <iframe> gives us load, a <video> gives us loadeddata; either one means there is something to
   see, so the spinner is removed. A timeout is the backstop for players that never fire an event. */
(function () {
  'use strict';

  function ready(frame) {
    frame.classList.add('is-ready');
  }

  function watch(frame) {
    if (frame.dataset.cjWatched) return;
    frame.dataset.cjWatched = '1';

    var done = false;
    function finish() {
      if (done) return;
      done = true;
      ready(frame);
    }

    var iframe = frame.querySelector('iframe');
    var video = frame.querySelector('video');

    if (iframe) {
      iframe.addEventListener('load', finish);
      /* an already-complete iframe fires no load event */
      try {
        var d = iframe.contentDocument;
        if (d && d.readyState === 'complete') finish();
      } catch (e) { /* cross origin, expected */ }
    }
    if (video) {
      ['loadeddata', 'canplay', 'playing', 'error'].forEach(function (ev) {
        video.addEventListener(ev, finish);
      });
    }

    /* backstop: never leave a spinner spinning forever */
    setTimeout(finish, 8000);
  }

  function init() {
    document.querySelectorAll('.cj-vv-frame').forEach(watch);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();